import React from "react";
import { AcademicCapIcon } from "@heroicons/react/24/solid";

// App logo + name, shared by the sidebar and the mobile top bar.
export default function Brand({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-md shadow-blue-600/25">
        <AcademicCapIcon className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className="text-lg font-bold tracking-tight text-slate-900">
        Question Bank
      </span>
    </div>
  );
}
